import { Access } from '@/modules/common/enums/access.enum.ts';
import type { CounterpartyManagerSections } from '@/modules/counterparty/counterparty-master/types/manager-form.ts';

export type CounterpartyMasterAccess = {
  counterparty: boolean;
  addresses: boolean;
  contacts: boolean;
  bankDetails: boolean;
  city: boolean;
  code: boolean;
  subordination: boolean;
  comment: boolean;
  execution: boolean;
  segmentsAdd: boolean;
  segmentsEdit: boolean;
  regionsAdd: boolean;
  regionsEdit: boolean;
};

export type AccessChecker = (access: Access) => boolean;

export function getCounterpartyMasterAccess(has: AccessChecker): CounterpartyMasterAccess {
  const counterparty = has(Access.CounterpartiesEdit);

  return {
    counterparty,
    addresses: has(Access.CounterpartiesEditAddressMasksAndContacts),
    contacts: has(Access.CounterpartiesEditAddressMasksAndContacts),
    bankDetails: has(Access.CounterpartiesBankDetails),
    city: has(Access.CounterpartiesCity),
    code: has(Access.CounterpartiesCode),
    subordination: counterparty,
    comment: counterparty,
    execution: counterparty,
    segmentsAdd: has(Access.SegmentsAdd),
    segmentsEdit: has(Access.SegmentsEdit),
    regionsAdd: has(Access.RegionsAdd),
    regionsEdit: has(Access.RegionsEdit),
  };
}

export function filterSectionsByAccess(
  sections: CounterpartyManagerSections,
  access: CounterpartyMasterAccess
): CounterpartyManagerSections {
  return {
    addresses: sections.addresses && access.addresses,
    contacts: sections.contacts && access.contacts,
    bankDetails: sections.bankDetails && access.bankDetails,
    subordination: sections.subordination && access.subordination,
    comment: sections.comment && access.comment,
  };
}

export function isMasterSectionVisible(
  section: keyof CounterpartyManagerSections,
  sections: CounterpartyManagerSections,
  access: CounterpartyMasterAccess
): boolean {
  return sections[section] && access[section];
}
